export default __webpack_public_path__ + "static/media/south-africa.ccf68c72.png";